module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-20-cd76a74491b1df5dbc4dd5a66f2f61c4.jpg";